<template>
	<div class="o-wrap">
		<el-page-header @back="$router.go(-1)" content="观展公司" />
		<div class="counst">
			<el-table :data="tableData" border>
				<el-table-column fixed prop="company" label="公司名" />
				<el-table-column prop="department" label="展品" />
				<el-table-column prop="post" label="面积" />
				<el-table-column prop="name" label="联系人" />
				<el-table-column prop="phone" label="联系电话" />
				<el-table-column prop="email" label="邮箱" />
				<el-table-column prop="zhanwei"  label="展位号">
					<!-- <template slot-scope="scope">
						{{scope.row}}
						<el-button type="text" @click="seeZhan(scope.row)">查看展位号</el-button>
					</template> -->
				</el-table-column>
			
				<el-table-column label="状态">
					<template slot-scope="scope">
						<span v-if="scope.row.is_shop>0">已开通</span>
						<span v-else>未开通</span>
						<!-- <el-switch v-model="scope.row.news_is_no" active-color="#13ce66" :active-value="1" :inactive-value="0" @change="statusChange(scope.row)" /> -->
					</template>
				</el-table-column>
				<!-- <el-table-column label="操作">
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="handleEdit(scope.row)">修改</el-button>
						<el-button type="text" size="small" @click="handleAllShelf(scope.row)"
							v-if="scope.row.state==1">下架</el-button>
						<el-button type="text" size="small" @click="handleAllPut(scope.row)" v-if="scope.row.state==0">
							上架</el-button>
						<el-button type="text" size="small" @click="handleDel(scope.row)">删除</el-button>
					</template>
				</el-table-column> -->
			</el-table>
			<el-pagination background layout="prev, pager, next" :total="total" :page-size="15" hide-on-single-page
				@current-change="currentChange" />
		</div>


	</div>
</template>

<script>
	import Axios from 'axios'
	export default {
		data() {
			return {
				tableData: [],
				p: 1,
				total: 0,
				a: 1,
				ids: '',
				state: '',
			}
		},
		created() {
			this.ids = this.$route.query.id
			this.getData()
		},
		methods: {
			getData() {
				Axios.post('Exhibition-Admin-getExhibitorSignUp', this.$qs.stringify({
					type: 2,
					exhibition_id: this.ids,
					user_id: this.$store.state.USER_ID,
				})).then(data => {
					this.tableData = data.data.data
					let list = []
					data.data.fenqu.map((item) => {
						list.push({
							"name": item,
							"value":item
						})
					})
					this.form.fenqu = list
					// this.total = Number(data.count)
				
					// document.body.scrollTop = document.documentElement.scrollTop = 0
				})
			},
		}
	}
</script>

<style scoped>
	.el-button+span {
		margin-left: 10px;
	}

	.el-pagination {
		text-align: center;
		margin-top: 20px;
	}
</style>
